<template>
  <div>
    <div v-if="appUtilities.moduleLoadingSeven">
      <BaseComponentLoader />
    </div>
    <div v-else>
      <form @submit.prevent="submitForm">
        <div class="row">
          <div class="col-12">
            <CustomerAccountCard
              :account="ft.stageOneResponse"
              destination="To"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div>
              <div class="form-group">
                <label>Account Class</label>
                <multiselect
                  v-model="formBody.accountClass"
                  :options="accountClassOptions"
                  @close="$v.formBody.accountClass.$touch()"
                  placeholder="Account Class"
                ></multiselect>
              </div>

              <template v-if="$v.formBody.accountClass.$error">
                <p
                  v-if="!$v.formBody.accountClass.required"
                  class="form-error-message"
                >
                  Account Class is required
                </p>
              </template>
            </div>
          </div>

          <div class="col-sm-6">
            <div>
              <div class="form-group">
                <label>FT Product</label>
                <multiselect
                  v-model="formBody.ftProductCode"
                  :options="ftProductCodeUtilityOption"
                  @close="$v.formBody.ftProductCode.$touch()"
                  placeholder="FT Product"
                ></multiselect>
              </div>
              <template v-if="$v.formBody.ftProductCode.$error">
                <p
                  v-if="!$v.formBody.ftProductCode.required"
                  class="form-error-message"
                >
                  FT Product is required
                </p>
              </template>
            </div>
          </div>

          <div class="col-sm-6">
            <div>
              <BaseInput
                :inputType="'amount'"
                v-model="formBody.amount"
                placeholder="Amount"
                :hasPreIcon="false"
                :label="'Amount'"
                step="0.01"
                :class="{
                  error: $v.formBody.amount.$error
                }"
                @blur="$v.formBody.amount.$touch()"
              >
              </BaseInput>

              <template v-if="$v.formBody.amount.$error">
                <p
                  v-if="!$v.formBody.amount.required"
                  class="form-error-message"
                >
                  Amount is required
                </p>
              </template>
            </div>
          </div>

          <div class="col-sm-6">
            <div>
              <BaseInput
                :inputType="'number'"
                v-model="formBody.tenure"
                placeholder="Tenure"
                :hasPreIcon="false"
                :label="'Tenure (days)'"
                :class="{
                  error: $v.formBody.tenure.$error
                }"
                @blur="$v.formBody.tenure.$touch()"
              >
              </BaseInput>

              <template v-if="$v.formBody.tenure.$error">
                <p
                  v-if="!$v.formBody.tenure.required"
                  class="form-error-message"
                >
                  Tenure is required
                </p>
              </template>
            </div>
          </div>

          <div class="col-sm-6">
            <div>
              <BaseInput
                :inputType="'number'"
                v-model="formBody.rate"
                placeholder="Rate"
                :hasPreIcon="false"
                :label="'Rate'"
                step="0.01"
                :class="{
                  error: $v.formBody.rate.$error
                }"
                @blur="$v.formBody.rate.$touch()"
              >
              </BaseInput>

              <template v-if="$v.formBody.rate.$error">
                <p v-if="!$v.formBody.rate.required" class="form-error-message">
                  Rate is required
                </p>
              </template>
            </div>
          </div>

          <div class="col-sm-6">
            <div>
              <BaseInput
                :inputType="'number'"
                v-model="formBody.penalty"
                placeholder="Penalty"
                :hasPreIcon="false"
                :label="'Penalty'"
                :class="{
                  error: $v.formBody.penalty.$error
                }"
                @blur="$v.formBody.penalty.$touch()"
              >
              </BaseInput>

              <template v-if="$v.formBody.penalty.$error">
                <p
                  v-if="!$v.formBody.penalty.required"
                  class="form-error-message"
                >
                  Penalty is required
                </p>
              </template>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <p class="text-left">
              <span>
                <button
                  @click="goBackToStageOne"
                  class="btn btn-secondary mr-1"
                >
                  Back
                </button>
              </span>
            </p>
          </div>
          <div class="col-sm-6">
            <p class="text-right">
              <span v-if="loader.actionButtonLoader" class="formLoaderHold">
                <BaseComponentLoader />
              </span>
              <span v-else>
                <button type="submit" class="btn btn-primary mr-1">
                  Submit
                </button>
              </span>
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import StoreUtils from "../../../../../utils/BaseUtils/StoreUtils";
import { required } from "vuelidate/lib/validators";
import CustomerAccountCard from "../../../Cards/FT/CustomerAccountCard";

export default {
  name: "FixedDepositFinalForm",
  components: { CustomerAccountCard },
  data() {
    return {
      formBody: this.freshFormBodyObject()
    };
  },
  computed: {
    ...mapState(["ft", "loader", "appUtilities"]),
    ...mapGetters({
      ftProductCodeUtilityOption: "appUtilities/getFtProductCodeUtilityOption",
      getAccountClassFromOptionUtility: "appUtilities/getAccountClassFromOptionUtility",
      accountClassOption: "appUtilities/getAccountClass2UtilityOption"
    }),
    accountClassOptions() {
      return StoreUtils.rootGetters(
        "appUtilities/getAccountClassTypeFixedUtilityOption"
      );
    }
  },
  validations: {
    formBody: {
      accountClass: { required },
      ftProductCode: { required },
      amount: { required },
      tenure: { required },
      rate: { required },
      penalty: { required }
    }
  },
  created() {
    StoreUtils.dispatch("appUtilities/fetchAllFundsTransferProduct");
    StoreUtils.dispatch("appUtilities/fetchAllAccountClass2");
  },
  mounted() {
  },
  methods: {
    goBackToStageOne() {
      StoreUtils.dispatch(StoreUtils.actions.ft.GO_BACK_TO_STAGE_ONE);
    },
    submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        StoreUtils.commit("form/BUILD_FORM_BODY", this.formBody);
        StoreUtils.dispatch("investment/createFixedDeposit");
      }
    },

    freshFormBodyObject() {
      return {
        source: "WEB"
      };
    }
  }
};
</script>

<style scoped></style>
